import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import Template from './ListerTitle.template'
import { searchTypes } from '../../config'
import * as Styled from './styles'

const ListerTitle = props => {
  const {
    inputSearchTerm,
    searchTerm,
    categoryName,
    isCannedSearch,
    hasBrandSuggestions,
    brandSuggestions,
    spellcheckedSearch,
    searchType,
    fallBackCategoryName,
    categoryUnmatchCallback,
    pageType,
    enableCommunicatingRelevancy
  } = props

  const displayCatMatchExperience = false
  const displayTermInCategory =
    searchType === null &&
    categoryName &&
    inputSearchTerm &&
    inputSearchTerm.toLowerCase() !== categoryName.toLowerCase()

  switch (true) {
    case pageType === 'directory':
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            <Styled.SearchTerm>{searchTerm}</Styled.SearchTerm>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case displayCatMatchExperience:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            {!isCannedSearch && (
              <h4 data-el='search-no-cat-match-label'>
                {Template.categ_match_top}
                <br />
                {Template.categ_match_bottom.start}
                {inputSearchTerm}
                {Template.categ_match_bottom.end}{' '}
                <a href='' onClick={categoryUnmatchCallback}>
                  here
                </a>
                .
              </h4>
            )}
            <Styled.SearchTerm>{categoryName || searchTerm}</Styled.SearchTerm>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case hasBrandSuggestions:
      let type = 'default'
      if (!!brandSuggestions[0].type && brandSuggestions[0].type === 'category_no_brand') {
        if (searchType === searchTypes.NRS) {
          type = 'category_no_results'
        } else {
          type = 'category_no_brand'
        }
      }
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            {!isCannedSearch && (
              <h4 data-el='search-nic-label'>
                {Template[type].start}
                <strong>{inputSearchTerm}</strong>
                {Template[type].end}
              </h4>
            )}
            <Styled.SearchTerm>{categoryName || searchTerm}</Styled.SearchTerm>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case displayTermInCategory:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            <h4 data-el='search-title__label'>
              {Template.filter_by_category.start}
              {inputSearchTerm}
              {Template.filter_by_category.end}
            </h4>
            <h1>{categoryName}</h1>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case spellcheckedSearch && !!inputSearchTerm:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            <h4 data-el='search-replacement__label'>
              {Template.spellcheckTitleStart}
              <strong>{inputSearchTerm}</strong>
              {Template.spellcheckTitleEnd}
            </h4>
            <Styled.SearchTerm>{searchTerm}</Styled.SearchTerm>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case !!categoryName:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            <Styled.SearchTerm aria-hidden='true' dangerouslySetInnerHTML={{ __html: categoryName }} />
            <span className='sr-only'>{categoryName}</span>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    case !!searchTerm:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            {!isCannedSearch && (
              <h4 data-el='search-title__label'>
                {enableCommunicatingRelevancy ? Template.title_relevancy_1 : Template.title}
              </h4>
            )}
            <Styled.SearchTerm>{inputSearchTerm}</Styled.SearchTerm>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
    default:
      return (
        <ErrorBoundary>
          <Styled.SearchTitle data-el='search-title' tabIndex='0' role='heading' aria-level='1'>
            <Styled.SearchTerm aria-hidden='true' dangerouslySetInnerHTML={{ __html: fallBackCategoryName }} />
            <span className='sr-only'>{fallBackCategoryName}</span>
          </Styled.SearchTitle>
        </ErrorBoundary>
      )
  }
}

ListerTitle.propTypes = {
  searchTerm: PropTypes.string,
  categoryName: PropTypes.string,
  isCannedSearch: PropTypes.bool,
  spellcheckedSearch: PropTypes.bool,
  inputSearchTerm: PropTypes.string,
  hasBrandSuggestions: PropTypes.bool,
  brandSuggestions: PropTypes.array,
  searchType: PropTypes.string,
  pageType: PropTypes.string,
  enableCommunicatingRelevancy: PropTypes.bool,
  fallBackCategoryName: PropTypes.string,
  categoryUnmatchCallback: PropTypes.func
}

ListerTitle.defaultProps = {
  searchTerm: '',
  categoryName: '',
  isCannedSearch: false,
  spellcheckedSearch: false,
  inputSearchTerm: '',
  hasBrandSuggestions: false,
  brandSuggestions: [],
  searchType: null,
  pageType: null,
  enableCommunicatingRelevancy: false,
  fallBackCategoryName: '',
  categoryUnmatchCallback: () => {}
}

export default React.memo(ListerTitle)
